export const PASSWORD_VALIDATE = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+}{"':;?/>.<,])(?=.*[^\s]).{8,}$/);
export const EMAIL_PATTERN = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export const PLAN_MONTHS = [
    {
        label: '1 Month',
        value: '1'
    },
    {
        label: '2 Month',
        value: '2'
    },
    {
        label: '3 Month',
        value: '3'
    },
    {
        label: '4 Month',
        value: '4'
    },
    {
        label: '5 Month',
        value: '5'
    },
    {
        label: '6 Month',
        value: '6'
    },
    {
        label: '7 Month',
        value: '7'
    },
    {
        label: '8 Month',
        value: '8'
    },
    {
        label: '9 Month',
        value: '9'
    },
    {
        label: '10 Month',
        value: '10'
    },
    {
        label: '11 Month',
        value: '11'
    },
    {
        label: '12 Month',
        value: '12'
    }
];
